import TopMenu from "../components/topMenu";
import {Button, Card, Col, Container, FormControl, FormGroup, FormLabel, Row} from "react-bootstrap";
import axios from "axios";
import Helper from "../helper";
import Error from "../components/error";
import {useForm} from "react-hook-form";
import {useState} from "react";
import {NotificationManager} from "react-notifications";
import { useNavigate } from "react-router-dom";

const Forgot = () => {

    const {register, handleSubmit, control, reset, getValues, formState: {errors}} = useForm({
        defaultValues: {
            first_name: '',
            last_name: '',
            license_id: '',
            password: '',
            cpassword: '',
        }
    });

    const navigate = useNavigate();

    const [showPasswordForm, setShowPasswordForm] = useState(false);

    const next = async () => {
        let first_name = getValues("first_name");
        let last_name = getValues("last_name");
        let license_id = getValues("license_id");
        let result = await axios.post(Helper.URI('check-forgot'), {first_name, last_name, license_id})
        if (!result.data?.error) {
            setShowPasswordForm(true);
        } else {
            NotificationManager.error(result.data?.error);
        }
    }

    const back = () => {
        setShowPasswordForm(false);
    }

    const onSubmit = async data => {
        let result = await axios.post(Helper.URI('change-password'), data)
        if (!result.data?.error) {
            NotificationManager.success('Password changed successfully.');
            let backLink = sessionStorage.getItem('backLink');
            if(backLink){
                document.location.href=backLink;
            }else{
                document.location.href='/login';
            }
        } else {
            NotificationManager.error(result.data?.error);
        }
    }

    return <>
        <TopMenu/>
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={5}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Card>
                            <Card.Header>ลืมรหัสผ่าน</Card.Header>
                            <Card.Body>
                                {!showPasswordForm ?
                                    <>
                                        <FormGroup>
                                            <FormLabel>ชื่อ</FormLabel>
                                            <FormControl {...register('first_name', {required: "กรุณากรอกชื่อ"})}/>
                                            <Error>{errors?.first_name?.message}</Error>
                                        </FormGroup>
                                        <FormGroup>
                                            <FormLabel>นามสกุล</FormLabel>
                                            <FormControl {...register('last_name', {required: "กรุณากรอกนามสกุล"})}/>
                                            <Error>{errors?.last_name?.message}</Error>
                                        </FormGroup>
                                        <FormGroup>
                                            <FormLabel>เลขใบประกอบวิชาชีพ (ระบุเฉพาะตัวเลข)</FormLabel>
                                            <FormControl {...register('license_id', {
                                                required: "กรุณากรอก เลขใบประกอบวิชาชีพ",
                                                pattern: {
                                                    value: /^[0-9]+$/,
                                                    message: "เลขใบประกอบวิชาชีพ ต้องเป็นตัวเลขเท่านั้น"
                                                }
                                            })}/>
                                            <Error>{errors?.license_id?.message}</Error>
                                        </FormGroup>
                                        <div className="text-end mt-4">
                                            <Button onClick={e => navigate('/login')} variant='danger' className="me-2">ยกเลิก</Button>
                                            <Button onClick={e => next()} variant='warning'>ถัดไป</Button>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <FormGroup>
                                            <FormLabel>กำหนด Password ใหม่</FormLabel>
                                            <FormControl
                                                type='password' {...register('password',
                                                {
                                                    required: "กรุณากรอก Password",
                                                    pattern: {
                                                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/,
                                                        message: "ต้องมีตัวอักษร(เล็ก-ใหญ่) และตัวเลขรวมกันอย่างน้อย 6 หลัก เช่น Abc123"
                                                    }
                                                })}/>
                                            <Error>{errors?.password?.message}</Error>
                                        </FormGroup>
                                        <FormGroup>
                                            <FormLabel>ยืนยัน Password</FormLabel>
                                            <FormControl type='password' {...register('cpassword', {
                                                required: "กรุณากรอกยืนยัน Password", validate: {
                                                    matched: v => {
                                                        let password = getValues('password');
                                                        return v === password ? true : 'คุณกรอกรหัสผ่านไม่ตรงกัน';
                                                    }
                                                }
                                            })}/>
                                            <Error>{errors?.cpassword?.message}</Error>
                                            <Error>{JSON.stringify(errors?.cpassword?.matched)}</Error>
                                        </FormGroup>
                                        <div className="text-end mt-4">
                                            <Button onClick={e => back()} variant='warning'
                                                    className="me-2">กลับ</Button>
                                            <Button type='submit' onClick={e => next()}>เปลี่ยนรหัสผ่าน</Button>
                                        </div>
                                    </>
                                }
                            </Card.Body>
                        </Card>
                    </form>
                </Col>
            </Row>
        </Container>
    </>
}
export default Forgot;
